import { Box, Typography } from "@mui/material";

type Props = {
  title: string;
  subtitle?: string;
  views?: number;
  posts?: number;
  averageViewedPercentage?: number;
  averageViewedDurationSec?: number;
  topCountries?: string;
  onClick?: () => void;
  mode?: "default" | "compact";
  countLabel?: string;
  countValue?: number;
};

const ContentHubTrendCard = ({
  title,
  subtitle,
  views,
  posts,
  averageViewedPercentage,
  averageViewedDurationSec,
  topCountries,
  onClick,
  mode = "default",
  countLabel,
  countValue,
}: Props) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        minWidth: "300px",
        gap: 1,
        cursor: onClick ? "pointer" : "default",
        "&:hover": onClick
          ? { opacity: 0.9, transform: "scale(1.03)", transition: "all 0.2s ease" }
          : {},
      }}
    >
      <Box
        sx={{
          width: "100%",
          minHeight: "220px",
          backgroundColor: "#E87722",
          borderRadius: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.25,
          padding: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontWeight: 700,
            color: "#ffffff",
            fontSize: "28px",
            lineHeight: 1.15,
            wordBreak: "break-word",
          }}
        >
          {title}
        </Typography>

        {subtitle ? (
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: 500,
              color: "#fff",
              fontSize: "16px",
              opacity: 0.9,
            }}
          >
            {subtitle}
          </Typography>
        ) : null}

        {mode === "compact" ? (
          <Box sx={{ mt: 2, textAlign: "center" }}>
            {countLabel ? (
              <Typography sx={{ color: "#fff", fontSize: "12px", opacity: 0.9 }}>
                {countLabel}
              </Typography>
            ) : null}
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "32px" }}>
              {countValue ?? "—"}
            </Typography>
          </Box>
        ) : (
          <>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 1.5,
                width: "100%",
                maxWidth: "420px",
                mt: 1,
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <Typography sx={{ color: "#fff", fontSize: "12px", opacity: 0.9 }}>
                  Views
                </Typography>
                <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
                  {views ?? "—"}
                </Typography>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <Typography sx={{ color: "#fff", fontSize: "12px", opacity: 0.9 }}>
                  Posts
                </Typography>
                <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
                  {posts ?? "—"}
                </Typography>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <Typography sx={{ color: "#fff", fontSize: "12px", opacity: 0.9 }}>
                  Avg Viewed %
                </Typography>
                <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
                  {averageViewedPercentage ?? "—"}
                </Typography>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <Typography sx={{ color: "#fff", fontSize: "12px", opacity: 0.9 }}>
                  Avg Duration (s)
                </Typography>
                <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
                  {averageViewedDurationSec ?? "—"}
                </Typography>
              </Box>
            </Box>

            {topCountries ? (
              <Typography
                sx={{
                  mt: 1,
                  textAlign: "center",
                  color: "#fff",
                  fontSize: "12px",
                  opacity: 0.9,
                }}
              >
                Top Countries: {topCountries}
              </Typography>
            ) : null}
          </>
        )}
      </Box>
    </Box>
  );
};

export default ContentHubTrendCard;